export default __webpack_public_path__ + "static/media/card_back.b2113f64.png";